import { ErrorBoundary, Illustration, SearchInput, Text, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box, Center, View } from 'native-base';
import React from 'react';

import { AllAdvisorsOrAllPartnersWarning } from './components/AllAdvisorsOrAllPartnersWarning';
import { HeaderSection } from './components/HeaderSection';
import { TradingCustomerListTable } from './components/TradingCustomerListTable';
import { Loading } from './components/TradingCustomerListTable/components/Loading';
import { searchPlaceholder } from './constants';
import { TradingTypes } from './types';

export const ContainerMobile: React.FC<TradingTypes.Props> = ({
  isMobile,
  onClearSearchTerm,
  onSetSearchTerm,
  onLoadMore,
  tradingList,
  tradingListLoading,
  filtered,
  tradingListError,
  handleNavigate,
  renderedItems,
  onRefresh,
  updatedAt,
}) => {
  return (
    <View px={Spacing['inline.xxxs']} width="100%" minW="container" flex={1}>
      <HeaderSection
        onRefresh={onRefresh}
        updatedAt={updatedAt}
        title={'Day trade'}
        isMobile={isMobile}
      />

      <Box w="100%" bg="transparent">
        <VStack space="stack.xxxs">
          <SearchInput
            isMobile={true}
            isLoading={tradingListLoading}
            onClear={onClearSearchTerm}
            onSearch={onSetSearchTerm}
            placeholder={searchPlaceholder}
          />
          <AllAdvisorsOrAllPartnersWarning />

          {(tradingListError && filtered && (
            <VStack alignItems="center">
              <VStack alignItems="center" space={Spacing['stack.quarck']}>
                <Illustration name="NotFoundIllustration" testId={'empty-illustration'} />
                <Text
                  textAlign={'center'}
                  paddingTop={Spacing['stack.xxxs']}
                  fontSize={Utils.Responsive.All({
                    phone: Typography['fontsize.xs'],
                    tablet: Typography['fontsize.xs'],
                    desktop: Typography['fontsize.md'],
                  })}
                  variant="bold"
                  color="neutral.black">
                  Nenhum resultado corresponde à sua pesquisa.
                </Text>
                <Text
                  textAlign={'center'}
                  fontSize={Utils.Responsive.All({
                    phone: Typography['fontsize.xs'],
                    tablet: Typography['fontsize.xs'],
                    desktop: Typography['fontsize.md'],
                  })}
                  lineHeight="medium"
                  color="neutral.black">
                  Por favor, verifique o campo informado e tente novamente.
                </Text>
              </VStack>
            </VStack>
          )) ||
            (tradingListError && (
              <Center flex={1} backgroundColor={Color['neutral.white']}>
                <ErrorBoundary onRefresh={onRefresh} />
              </Center>
            ))}

          {!tradingListError && !tradingListLoading && (
            <TradingCustomerListTable
              renderedItems={renderedItems}
              handleNavigate={handleNavigate}
              isMobile
              tradingList={tradingList}
              onLoadMore={onLoadMore}
              filtered={filtered}
            />
          )}

          {tradingListLoading && <Loading />}
        </VStack>
      </Box>
    </View>
  );
};
